export default {
  // 快捷键
  // 支持快捷键 例如 ctrl+shift+s
  hotkey: {
    search: {
      open: 's',
      close: 'esc'
    }
  },
  // 侧边栏默认折叠状态
  menu: {
    asideCollapse: false,
    asideTransition: false
  },
  // 在读取持久化数据失败时默认页面
  page: {
    opened: [{
      name: 'index',
      fullPath: '/index',
      meta: {
        title: 'index',
        auth: false
      }
    }]
  },
  // 菜单搜索
  search: {
    enable: true
  },
  // 注册的主题
  theme: {
    list: [{
      title: 'd2admin 经典',
      name: 'd2',
      preview: 'image/theme/d2/preview@2x.png'
    }, {
      title: 'Chester',
      name: 'chester',
      preview: 'image/theme/chester/preview@2x.png'
    }, {
      title: '紫罗兰',
      name: 'violet',
      preview: 'image/theme/violet/preview@2x.png'
    }, {
      title: '简约线条',
      name: 'line',
      backgroundImage: 'image/theme/line/bg.jpg',
      preview: 'image/theme/line/preview@2x.png'
    }, {
      title: '流星',
      name: 'star',
      backgroundImage: 'image/theme/star/bg.jpg',
      preview: 'image/theme/star/preview@2x.png'
    }, {
      title: 'Tomorrow Night Blue (vsCode)',
      name: 'tomorrow-night-blue',
      preview: 'image/theme/tomorrow-night-blue/preview@2x.png'
    }]
  },
  // 是否默认开启页面切换动画
  transition: {
    active: false
  },
  // 设置时区
  time: {
    list: [{
      label: "零时区",
      name: 0
    }, {
      label: "东一区",
      name: 1
    }, {
      label: "东二区",
      name: 2
    }, {
      label: "东三区",
      name: 3
    }, {
      label: "东四区",
      name: 4
    }, {
      label: "东五区",
      name: 5
    }, {
      label: "东六区",
      name: 6
    }, {
      label: "东七区",
      name: 7
    }, {
      label: "东八区",
      name: 8
    }, {
      label: "东九区",
      name: 9
    }, {
      label: "东十区",
      name: 10
    }, {
      label: "东十一区",
      name: 11
    }, {
      label: "东十二区",
      name: 12
    }, {
      label: "西一区",
      name: -1
    }, {
      label: "西二区",
      name: -2
    }, {
      label: "西三区",
      name: -3
    }, {
      label: "西四区",
      name: -4
    }, {
      label: "西五区",
      name: -5
    }, {
      label: "西六区",
      name: -6
    }, {
      label: "西七区",
      name: -7
    }, {
      label: "西八区",
      name: -8
    }, {
      label: "西九区",
      name: -9
    }, {
      label: "西十区",
      name: -10
    }, {
      label: "西十一区",
      name: -11
    }]
  }
};